import { forwardRef, LegacyRef } from "react";

interface DefaultNoAccessSvgProps {
  title?: string;
  titleId?: string;
}

const DefaultNoAccessSvg = forwardRef(
  (
    { title: _title, titleId: _titleId, ...props }: DefaultNoAccessSvgProps,
    ref: LegacyRef<SVGSVGElement>,
  ) => (
    <svg
      ref={ref}
      width="88px"
      height="88px"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 120 120"
      aria-hidden="true"
      {...props}
    >
      <path
        d="M5.87518 79.1994C17.9118 101.69 52.2755 106.724 82.6347 90.4564C112.994 74.1885 127.848 42.7246 115.834 20.2338C109.874 9.11663 98.4662 2.26451 84.7766 0.14362C70.7844 -2.02389 65.1968 20.933 49.8542 29.1602C34.6746 37.2942 16.4683 32.866 6.57362 41.7691C-3.87983 51.1616 -0.131485 67.9423 5.87518 79.1994Z"
        fill="#DEECFF"
      />
      <path
        d="M34.7495 83.1222C34.7495 79.597 37.6073 76.7393 41.1325 76.7393H42.9805C47.4581 76.7393 50.5441 81.2293 48.9396 85.4095L46.1608 92.6492C45.5926 94.1295 44.171 95.1066 42.5854 95.1066H38.5793C36.4642 95.1066 34.7495 93.392 34.7495 91.2768V83.1222Z"
        fill="#0052C4"
      />
      <path
        d="M30.6904 83.1222C30.6904 79.597 33.5482 76.7393 37.0734 76.7393H38.9215C43.399 76.7393 46.4851 81.2293 44.8806 85.4095L42.1018 92.6492C41.5336 94.1295 40.1119 95.1066 38.5263 95.1066H34.5202C32.4051 95.1066 30.6904 93.392 30.6904 91.2768V83.1222Z"
        fill="#80B5FF"
      />
      <path
        d="M80.2239 85.2251C78.7761 81.0761 81.8562 76.7393 86.2505 76.7393H88.0341C91.6174 76.7393 94.4986 79.6883 94.4153 83.2707L94.227 91.3659C94.1786 93.4458 92.4787 95.1066 90.3982 95.1066H86.3918C84.763 95.1066 83.3124 94.0764 82.7758 92.5386L80.2239 85.2251Z"
        fill="#0052C4"
      />
      <path
        d="M76.592 85.2251C75.1443 81.0761 78.2243 76.7393 82.6187 76.7393H84.4022C87.9856 76.7393 90.8668 79.6883 90.7835 83.2707L90.5952 91.3659C90.5468 93.4458 88.8468 95.1066 86.7664 95.1066H82.7599C81.1312 95.1066 79.6806 94.0764 79.144 92.5386L76.592 85.2251Z"
        fill="#80B5FF"
      />
      <path
        d="M27.1187 17.8724C27.1187 10.822 32.8342 5.10645 39.8846 5.10645H95.1065C102.157 5.10645 107.872 10.822 107.872 17.8724V72.2398C107.872 79.2902 102.157 85.0057 95.1065 85.0057H39.8846C32.8342 85.0057 27.1187 79.2902 27.1187 72.2398V17.8724Z"
        fill="#0052C4"
      />
      <path
        d="M17.8726 17.8724C17.8726 10.822 23.5881 5.10645 30.6385 5.10645H85.8604C92.9109 5.10645 98.6264 10.822 98.6264 17.8724V72.2398C98.6264 79.2902 92.9109 85.0057 85.8604 85.0057H30.6385C23.5881 85.0057 17.8726 79.2902 17.8726 72.2398V17.8724Z"
        fill="#B3D3FF"
      />
      <path
        d="M25.563 19.2038C25.563 15.6786 28.4207 12.8208 31.946 12.8208H84.5522C88.0774 12.8208 90.9351 15.6786 90.9351 19.2038V70.9554C90.9351 74.4807 88.0774 77.3384 84.5522 77.3384H31.946C28.4208 77.3384 25.563 74.4807 25.563 70.9554V19.2038Z"
        fill="#80B5FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.946 14.7357C29.4783 14.7357 27.4779 16.7361 27.4779 19.2038V70.9554C27.4779 73.4231 29.4783 75.4235 31.946 75.4235H84.5522C87.0198 75.4235 89.0202 73.4231 89.0202 70.9554V19.2038C89.0202 16.7361 87.0198 14.7357 84.5522 14.7357H31.946ZM31.946 12.8208C28.4207 12.8208 25.563 15.6786 25.563 19.2038V70.9554C25.563 74.4807 28.4208 77.3384 31.946 77.3384H84.5522C88.0774 77.3384 90.9351 74.4807 90.9351 70.9554V19.2038C90.9351 15.6786 88.0774 12.8208 84.5522 12.8208H31.946Z"
        fill="#106FF3"
      />
      <path
        d="M24.0679 26.0556C24.0679 24.6455 25.211 23.5024 26.6211 23.5024H27.2828C28.6929 23.5024 29.836 24.6455 29.836 26.0556V34.1946C29.836 35.6047 28.6929 36.7478 27.2828 36.7478H26.6211C25.211 36.7478 24.0679 35.6047 24.0679 34.1946V26.0556Z"
        fill="#0052C4"
      />
      <path
        d="M24.0679 25.8524C24.0679 24.5546 25.12 23.5024 26.4179 23.5024C27.7157 23.5024 28.7678 24.5546 28.7678 25.8524V34.3978C28.7678 35.6957 27.7157 36.7478 26.4179 36.7478C25.12 36.7478 24.0679 35.6957 24.0679 34.3978V25.8524Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.0679 34.8252H28.7678V35.4661L24.0679 35.4661V34.8252Z"
        fill="#6397FC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.0679 24.7842H28.7678V25.4251L24.0679 25.4251V24.7842Z"
        fill="#6397FC"
      />
      <path
        d="M24.0679 58.1006C24.0679 56.6905 25.211 55.5474 26.6211 55.5474H27.2828C28.6929 55.5474 29.836 56.6905 29.836 58.1006V66.2395C29.836 67.6496 28.6929 68.7927 27.2828 68.7927H26.6211C25.211 68.7927 24.0679 67.6496 24.0679 66.2395V58.1006Z"
        fill="#0052C4"
      />
      <path
        d="M24.0679 57.8973C24.0679 56.5995 25.12 55.5474 26.4179 55.5474C27.7157 55.5474 28.7678 56.5995 28.7678 57.8973V66.4427C28.7678 67.7406 27.7157 68.7927 26.4179 68.7927C25.12 68.7927 24.0679 67.7406 24.0679 66.4427V57.8973Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.0679 66.8701H28.7678V67.511L24.0679 67.511V66.8701Z"
        fill="#6397FC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.0679 56.8291H28.7678V57.47L24.0679 57.47V56.8291Z"
        fill="#6397FC"
      />
      <path
        d="M76.1943 38.8842C76.1943 37.1144 77.629 35.6797 79.3989 35.6797C81.1687 35.6797 82.6034 37.1144 82.6034 38.8842V52.1295C82.6034 53.8994 81.1687 55.3341 79.3989 55.3341C77.629 55.3341 76.1943 53.8993 76.1943 52.1295V38.8842Z"
        fill="#6397FC"
      />
      <path
        d="M74.9126 38.0297C74.9126 36.2599 76.3473 34.8252 78.1171 34.8252C79.8869 34.8252 81.3216 36.2599 81.3216 38.0297V51.2751C81.3216 53.0449 79.8869 54.4796 78.1171 54.4796C76.3473 54.4796 74.9126 53.0449 74.9126 51.275V38.0297Z"
        fill="#B3D3FF"
      />
      <path
        d="M76.1943 39.2046C76.1943 40.4435 75.19 41.4478 73.9512 41.4478C72.7123 41.4478 71.708 40.4435 71.708 39.2046C71.708 37.9657 72.7123 36.9614 73.9512 36.9614C75.19 36.9614 76.1943 37.9657 76.1943 39.2046Z"
        fill="white"
      />
      <path
        d="M76.1943 42.0884C76.1943 41.3805 76.7682 40.8066 77.4761 40.8066C78.1841 40.8066 78.7579 41.3805 78.7579 42.0884V44.2248C78.7579 44.9327 78.1841 45.5066 77.4761 45.5066C76.7682 45.5066 76.1943 44.9327 76.1943 44.2248V42.0884Z"
        fill="#B3D3FF"
      />
      <path
        d="M78.7579 38.2432C78.7579 38.9512 78.1841 39.525 77.4761 39.525C76.7682 39.525 76.1943 38.9512 76.1943 38.2432C76.1943 37.5353 76.7682 36.9614 77.4761 36.9614C78.1841 36.9614 78.7579 37.5353 78.7579 38.2432Z"
        fill="#B3D3FF"
      />
      <path
        d="M62.5222 43.7976C62.5222 50.8768 56.4486 56.6156 48.9564 56.6156C41.4642 56.6156 35.3906 50.8768 35.3906 43.7976C35.3906 36.7183 41.4642 30.9795 48.9564 30.9795C56.4486 30.9795 62.5222 36.7183 62.5222 43.7976Z"
        fill="#B3D3FF"
      />
      <path
        d="M61.2406 43.7976C61.2406 50.8768 55.5018 56.6156 48.4226 56.6156C41.3433 56.6156 35.6045 50.8768 35.6045 43.7976C35.6045 36.7183 41.3433 30.9795 48.4226 30.9795C55.5018 30.9795 61.2406 36.7183 61.2406 43.7976Z"
        fill="white"
      />
      <path
        d="M58.0356 43.7976C58.0356 48.6351 54.1141 52.5566 49.2766 52.5566C44.4391 52.5566 40.5176 48.6351 40.5176 43.7976C40.5176 38.9601 44.4391 35.0386 49.2766 35.0386C54.1141 35.0386 58.0356 38.9601 58.0356 43.7976Z"
        fill="#80B5FF"
      />
      <path
        d="M57.1811 43.7976C57.1811 48.6351 53.2596 52.5566 48.4221 52.5566C43.5846 52.5566 39.6631 48.6351 39.6631 43.7976C39.6631 38.9601 43.5846 35.0386 48.4221 35.0386C53.2596 35.0386 57.1811 38.9601 57.1811 43.7976Z"
        fill="#B3D3FF"
      />
      <path
        d="M52.4814 43.7973C52.4814 46.0391 50.6641 47.8564 48.4223 47.8564C46.1806 47.8564 44.3633 46.0391 44.3633 43.7973C44.3633 41.5556 46.1806 39.7383 48.4223 39.7383C50.6641 39.7383 52.4814 41.5556 52.4814 43.7973Z"
        fill="white"
      />
      <path
        d="M49.7042 32.6888C49.7042 33.2787 48.636 34.8251 48.636 34.8251C48.636 34.8251 47.5679 33.2787 47.5679 32.6888C47.5679 32.0988 48.0461 31.6206 48.636 31.6206C49.226 31.6206 49.7042 32.0988 49.7042 32.6888Z"
        fill="#0052C4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M48.2089 36.6408C48.2089 36.4638 48.3524 36.3203 48.5293 36.3203C48.7063 36.3203 48.8498 36.4638 48.8498 36.6408V38.3498C48.8498 38.5268 48.7063 38.6703 48.5293 38.6703C48.3524 38.6703 48.2089 38.5268 48.2089 38.3498V36.6408Z"
        fill="#6397FC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M48.2089 49.4589C48.2089 49.2819 48.3524 49.1384 48.5293 49.1384C48.7063 49.1384 48.8498 49.2819 48.8498 49.4589V51.1679C48.8498 51.3449 48.7063 51.4884 48.5293 51.4884C48.3524 51.4884 48.2089 51.3449 48.2089 51.1679V49.4589Z"
        fill="#6397FC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M55.7929 43.5838C55.9699 43.5838 56.1134 43.7273 56.1134 43.9043C56.1134 44.0813 55.9699 44.2247 55.7929 44.2247H54.0838C53.9068 44.2247 53.7634 44.0813 53.7634 43.9043C53.7634 43.7273 53.9068 43.5838 54.0838 43.5838H55.7929Z"
        fill="#6397FC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M42.9748 43.5838C43.1518 43.5838 43.2953 43.7273 43.2953 43.9043C43.2953 44.0813 43.1518 44.2247 42.9748 44.2247H41.2658C41.0888 44.2247 40.9453 44.0813 40.9453 43.9043C40.9453 43.7273 41.0888 43.5838 41.2658 43.5838H42.9748Z"
        fill="#6397FC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M53.5336 38.6298C53.6609 38.5069 53.8638 38.5105 53.9867 38.6379C54.1096 38.7652 54.106 38.9681 53.9786 39.091L52.7488 40.2778C52.6215 40.4007 52.4186 40.3971 52.2957 40.2697C52.1728 40.1424 52.1764 39.9395 52.3038 39.8166L53.5336 38.6298Z"
        fill="#6397FC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44.31 47.5309C44.4373 47.408 44.6402 47.4116 44.7631 47.5389C44.886 47.6663 44.8824 47.8691 44.755 47.992L43.5252 49.1789C43.3979 49.3017 43.195 49.2981 43.0721 49.1708C42.9492 49.0434 42.9528 48.8406 43.0802 48.7177L44.31 47.5309Z"
        fill="#6397FC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M53.8039 48.9084C53.9268 49.0358 53.9232 49.2387 53.7958 49.3616C53.6685 49.4845 53.4656 49.4809 53.3427 49.3535L52.1559 48.1237C52.033 47.9963 52.0366 47.7935 52.1639 47.6706C52.2913 47.5477 52.4942 47.5513 52.6171 47.6786L53.8039 48.9084Z"
        fill="#6397FC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44.9028 39.685C45.0257 39.8123 45.0221 40.0152 44.8947 40.1381C44.7674 40.261 44.5645 40.2574 44.4416 40.13L43.2548 38.9002C43.1319 38.7728 43.1355 38.57 43.2629 38.4471C43.3902 38.3242 43.5931 38.3278 43.716 38.4551L44.9028 39.685Z"
        fill="#6397FC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M55.1587 40.9187C55.3231 40.8533 55.5095 40.9334 55.575 41.0979C55.6405 41.2623 55.5603 41.4487 55.3959 41.5141L53.8081 42.1466C53.6437 42.2121 53.4573 42.1319 53.3918 41.9675C53.3263 41.8031 53.4065 41.6167 53.571 41.5512L55.1587 40.9187Z"
        fill="#6397FC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M43.2505 45.6621C43.415 45.5966 43.6013 45.6768 43.6668 45.8412C43.7323 46.0056 43.6521 46.192 43.4877 46.2575L41.9 46.8899C41.7355 46.9554 41.5492 46.8752 41.4837 46.7108C41.4182 46.5464 41.4984 46.36 41.6628 46.2945L43.2505 45.6621Z"
        fill="#6397FC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M51.5149 50.5337C51.5804 50.6981 51.5002 50.8845 51.3358 50.95C51.1714 51.0154 50.985 50.9353 50.9195 50.7708L50.2871 49.1831C50.2216 49.0187 50.3018 48.8323 50.4662 48.7668C50.6306 48.7013 50.817 48.7815 50.8825 48.9459L51.5149 50.5337Z"
        fill="#6397FC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M46.7716 38.6256C46.8371 38.79 46.7569 38.9763 46.5925 39.0418C46.4281 39.1073 46.2417 39.0271 46.1762 38.8627L45.5437 37.275C45.4783 37.1105 45.5584 36.9242 45.7229 36.8587C45.8873 36.7932 46.0737 36.8734 46.1392 37.0378L46.7716 38.6256Z"
        fill="#6397FC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M55.3118 46.5235C55.4739 46.5945 55.5478 46.7835 55.4768 46.9456C55.4059 47.1077 55.2169 47.1816 55.0548 47.1107L53.4891 46.4253C53.327 46.3543 53.2531 46.1654 53.3241 46.0032C53.3951 45.8411 53.584 45.7672 53.7462 45.8382L55.3118 46.5235Z"
        fill="#6397FC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M43.5695 41.3833C43.7317 41.4543 43.8056 41.6433 43.7346 41.8054C43.6636 41.9675 43.4747 42.0414 43.3125 41.9704L41.7469 41.2851C41.5848 41.2141 41.5109 41.0251 41.5818 40.863C41.6528 40.7009 41.8418 40.627 42.0039 40.698L43.5695 41.3833Z"
        fill="#6397FC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45.9101 50.6868C45.8392 50.8489 45.6502 50.9228 45.4881 50.8518C45.3259 50.7809 45.252 50.5919 45.323 50.4298L46.0084 48.8641C46.0793 48.702 46.2683 48.6281 46.4304 48.6991C46.5926 48.7701 46.6665 48.959 46.5955 49.1211L45.9101 50.6868Z"
        fill="#6397FC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M51.0503 38.9445C50.9793 39.1066 50.7903 39.1805 50.6282 39.1095C50.4661 39.0386 50.3922 38.8496 50.4631 38.6875L51.1485 37.1218C51.2195 36.9597 51.4084 36.8858 51.5706 36.9568C51.7327 37.0277 51.8066 37.2167 51.7356 37.3788L51.0503 38.9445Z"
        fill="#6397FC"
      />
    </svg>
  ),
);

export default DefaultNoAccessSvg;
